// Shared validation patterns used across views.

// Allows letters from all languages plus spaces, hyphens, and apostrophes.
// Disallows digits and punctuation like commas, exclamation points, etc.
export const NAME_REGEX = /^[\p{L} '-]+$/u;

// Basic email format: something@something.domain (no spaces).
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

